export default __webpack_public_path__ + "media/images/banner/banner-24-59e2d553945c7cab801f0b3c6ef38e48.jpg";